@if (question.VideoId) {
  <div class="game-question-video">
    <fgbcl-video-player [videoId]="question.VideoId"></fgbcl-video-player>
  </div>
} @else {
  <ng-container *ngIf="question.ImageUrl">
    <div class="fgbcl-game-question-image">
      <img [src]="question.ImageUrl | contentImage: '6'" alt="{{ question.Title }}" />
    </div>
  </ng-container>
}

<div class="fgbcl-game-question-text">
  {{ question.Title }}
</div>
<ng-container *ngIf="question.AnswerDisplayType == answerType.Text">
  <fgbcl-answer-type-text
    [answers]="question.Answers"
    [questionId]="question.Id"
    [groupId]="groupId"
    [groupType]="groupType"
    (answerSelected)="onAnswerSelected($event)"
    (loadingState)="loadingState.emit($event)"
    [isExternal]="isExternal"
  ></fgbcl-answer-type-text>
</ng-container>

<ng-container *ngIf="question.AnswerDisplayType == answerType.ImageAndText">
  <fgbcl-answer-type-text-and-image
    [answers]="question.Answers"
    [questionId]="question.Id"
    [groupId]="groupId"
    [groupType]="groupType"
    (answerSelected)="onAnswerSelected($event)"
    (loadingState)="loadingState.emit($event)"
    [isExternal]="isExternal"
  >
  </fgbcl-answer-type-text-and-image>
</ng-container>

<ng-container *ngIf="question.AnswerDisplayType == answerType.Score">
  <fgbcl-answer-multi-counter [answers]="question.Answers" [groupType]="groupType" (answerSelected)="onAnswerSelected($event)">
  </fgbcl-answer-multi-counter>
</ng-container>

<ng-container *ngIf="question.AnswerDisplayType == answerType.Counter">
  <fgbcl-answer-type-counter [answers]="question.Answers" [groupType]="groupType" (answerSelected)="onAnswerSelected($event)">
  </fgbcl-answer-type-counter>
</ng-container>

<ng-container *ngIf="question.AnswerDisplayType == answerType.Dropdown">
  <fgbcl-answer-type-dropdown [answers]="question.Answers" [groupType]="groupType" (answerSelected)="onAnswerSelected($event)">
  </fgbcl-answer-type-dropdown>
</ng-container>

<ng-container *ngIf="question.AnswerDisplayType == answerType.VideoCarousel">
  <fgbcl-answer-type-video-carousel
    [answers]="question.Answers"
    [questionId]="question.Id"
    [groupId]="groupId"
    [groupType]="groupType"
    (answerSelected)="onAnswerSelected($event)"
    (loadingState)="loadingState.emit($event)"
  ></fgbcl-answer-type-video-carousel>
</ng-container>
